import { InputHTMLAttributes } from "react";

type TextFieldProps = InputHTMLAttributes<HTMLInputElement> & {
	label: string;
	className?: string;
	fieldClassName?: string;
};

export function TextField({
	label,
	className = "",
	fieldClassName = "",
	id,
	...props
}: TextFieldProps) {
	const inputId = id ?? label.toLowerCase().replace(/[^a-z0-9]+/g, "-");

	return (
		<div className={`pf-field-group ${className}`.trim()}>
			<label className="pf-field-group__label" htmlFor={inputId}>
				{label}
			</label>
			<input
				id={inputId}
				className={`pf-input ${fieldClassName}`.trim()}
				{...props}
			/>
		</div>
	);
}
